import FooterItemComponent from "./FooterItemComponent";

export default FooterItemComponent;
